import React from 'react';
import './ProfileScheduleStrip.css';

// Monday first, the order the profile card has always drawn its week in.
export const DOW = [[1, 'M'], [2, 'T'], [3, 'W'], [4, 'T'], [5, 'F'], [6, 'S'], [0, 'S']];

const DAY_NAMES = { 0: 'Sun', 1: 'Mon', 2: 'Tue', 3: 'Wed', 4: 'Thu', 5: 'Fri', 6: 'Sat' };

// The week as words, for the strip's accessible name: "Mon–Fri" for exactly
// the five weekdays, otherwise the days in card order.
export function weekdayLabel(days) {
  const set = new Set(Array.isArray(days) ? days : []);
  if (set.size === 5 && [1, 2, 3, 4, 5].every((d) => set.has(d))) return 'Mon–Fri';
  const names = DOW.filter(([d]) => set.has(d)).map(([d]) => DAY_NAMES[d]);
  return names.length ? names.join(', ') : 'No days set';
}

// The card's seven-dot week. The profile card strip and the services page
// rows both draw it from here, so a row and its card can never disagree about
// which days a service works. The test ids are the card's, kept as they were.
export default function WeekdayStrip({ days }) {
  const on = new Set(Array.isArray(days) ? days : []);
  return (
    <div className="pv-anon-sched__strip" role="img" aria-label={weekdayLabel(days)}>
      {DOW.map(([d, l], i) => (
        <span
          key={i}
          data-testid={on.has(d) ? 'sched-day-on' : 'sched-day'}
          className={`pv-anon-sched__day${on.has(d) ? ' pv-anon-sched__day--on' : ''}`}
        >
          {l}
        </span>
      ))}
    </div>
  );
}
